import { Reveal } from "../lib/anim";

const STAGES = [
  { phase: "Now", region: "Georgia", body: "Serving Clarkston and surrounding communities through clinic partnerships." },
  { phase: "Next", region: "Southeastern U.S.", body: "Expanding kit distribution and education across the region." },
  { phase: "Future", region: "Nationwide", body: "Scaling the model wherever resources permit." },
];

export const Reach = () => (
  <section data-testid="reach" className="py-24 md:py-32 bg-[#F8FAFC] border-y hairline">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-brand-blue font-bold mb-4">Geographic Reach</p>
        <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-brand-ink max-w-2xl leading-[1.05]">
          Starting local. Building outward.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {STAGES.map((s, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="bg-white rounded-2xl p-8 border hairline h-full relative">
              <span className="font-mono text-xs uppercase tracking-widest text-brand-green">{s.phase}</span>
              <h3 className="font-display text-3xl text-brand-ink mt-3">{s.region}</h3>
              <p className="mt-4 text-brand-ink/60 leading-relaxed">{s.body}</p>
              <span className="absolute top-8 right-8 font-display text-5xl text-brand-blue/10">0{i + 1}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
